<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import { ROWS } from '@/components/ui/SkeletonLoaders/global-groups'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'HomepageGroupsFilterLoader'
})
const { SQUARE } = SKELETON_APPEARANCES
const { XS, SM } = SKELETON_SIZES
</script>

<template>
  <div class="hpgfl-Loader">
    <div v-for="row in ROWS.slice(0, 5)" :key="row.id" class="hpgfl-Loader_Row">
      <SkeletonItem
        :appearance="SQUARE"
        :color="row.color"
        :size="SM"
        border-radius="6px"
        style="flex-shrink: 0"
      />
      <SkeletonItem :size="XS" :width="row.name" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hpgfl-Loader {
  display: flex;
  flex-direction: column;
  gap: var(--ob-hpgf-item-gap);
}

.hpgfl-Loader_Row {
  height: var(--ob-hpgf-item-height);
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 8px;
}
</style>
